import { useEffect, useState } from 'react';

const COLLECT_JS_SRC = 'https://secure.nmi.com/token/Collect.js';
// PUBLIC tokenization key - safe in the browser.
const TOKENIZATION_KEY = process.env.REACT_APP_NMI_TOKENIZATION_KEY;

// Loads Collect.js fresh for each payment screen and tears it down on unmount.
export function useCollectJs() {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        let cancelled = false;

        const existing = document.querySelector(`script[src="${COLLECT_JS_SRC}"]`);
        if (existing) existing.remove();
        try {
            // eslint-disable-next-line no-undef
            if (window.CollectJS) delete window.CollectJS;
        } catch (e) {
            window.CollectJS = undefined;
        }

        const script = document.createElement('script');
        script.src = COLLECT_JS_SRC;
        script.async = true;
        script.setAttribute('data-tokenization-key', TOKENIZATION_KEY);

        const onLoad = () => { if (!cancelled) setLoaded(true); };
        const onError = () => { if (!cancelled) setLoaded(false); };
        script.addEventListener('load', onLoad);
        script.addEventListener('error', onError);

        document.body.appendChild(script);

        return () => {
            cancelled = true;
            script.removeEventListener('load', onLoad);
            script.removeEventListener('error', onError);
            // Tear down so the next payment screen mounts a clean Collect.js.
            script.remove();
            try {
                // eslint-disable-next-line no-undef
                if (window.CollectJS) delete window.CollectJS;
            } catch (e) {
                window.CollectJS = undefined;
            }
        };
    }, []);

    return loaded;
}